import { Base } from "ui/Scripts/source/framework/base";

export interface IIdCode {
    id: string;
    code: string;
}

export class IdCode implements IIdCode {
    id: string;
    code: string;

    constructor();
    constructor(obj: IIdCode);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.code = obj && obj.code || "";
    }

    static getTypedArray(untyped: any): IdCode[] {
        const result: IdCode[] = [];
        if (untyped) {
            for (let i = 0; i < untyped.length; i++) {
                result.push(new IdCode(untyped[i]));
            }
        }
        return result;
    }

    static getCodeById(idCodes: IdCode[], id: string): string {
        if (Base.isNullOrUndefined(idCodes) || Base.isNullOrEmpty(id)) return "";
        for (let i = 0; i < idCodes.length; i++) {
            if (idCodes[i].id !== id) continue;
            return idCodes[i].code;
        }
        return "";
    }

    static createIdCode(id: string, code: string): IdCode {
        const result = new IdCode();
        result.id = id;
        result.code = code;
        return result;
    }
}